export default __webpack_public_path__ + "static/media/blood3.cc441057.png";